export default {
    name: "indexView",
    data() {
        return {};
    },
    watch: {},
    created() {
    },
    async mounted() {
    },
    onUpdated() {
    },
    beforeDestroy() {
    },
    methods: {},
};
